export default __webpack_public_path__ + "static/media/lcs-online-background.5c28b63b.png";